import { SelectionBar } from '@/shared/ui';
import { ChangePriorityDialog, PlaceOnHoldDialog, CancelConsignmentDialog } from '@/features/consignment-actions';
import type { ConsignmentSummary } from '@/entities/consignments';

import { useConsignmentSelection } from '../model/use-consignment-selection';

interface ConsignmentSelectionBarProps {
  selectedIds: string[];
  consignments?: Pick<ConsignmentSummary, 'id' | 'statusCode'>[];
  onClearSelection?: () => void;
}

export function ConsignmentSelectionBar({ selectedIds, consignments, onClearSelection }: ConsignmentSelectionBarProps) {
  const { selectedCount, selectionActions, dialogs, isVisible } = useConsignmentSelection({
    selectedIds,
    consignments,
    onClearSelection
  });

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <SelectionBar selectedCount={selectedCount} actions={selectionActions} onClose={onClearSelection} />

      <ChangePriorityDialog
        open={dialogs.changePriority.open}
        onOpenChange={dialogs.changePriority.onOpenChange}
        onConfirm={(priority, comments) => dialogs.changePriority.onConfirm(priority, comments)}
      />

      <PlaceOnHoldDialog
        open={dialogs.placeOnHold.open}
        onOpenChange={dialogs.placeOnHold.onOpenChange}
        onConfirm={(remarks) => dialogs.placeOnHold.onConfirm(remarks)}
      />

      <CancelConsignmentDialog
        open={dialogs.cancel.open}
        onOpenChange={dialogs.cancel.onOpenChange}
        onConfirm={(reason, remarks) => dialogs.cancel.onConfirm(reason, remarks)}
      />
    </>
  );
}
